import { AccountStatusEnum } from "../SuperEnum";
import Tools from "../Tools";
import AccountVO from "../vo/AccountVO";
import ad_account from "../vo/dbvo/ad_account";

export type InputCreateAccount = {
    account: string,
    password: string,
    nick_name?: string,
    industry_ids: number[],
    agent_lv?: number
};

export type InputSetUserBalance = {
    UID: string,
    Amount: number
};

export type InputUpdateAccountUserInfo = {
    /**
     * 头像
     */
    Profile?: File,
    /**
     * 密码
     */
    Password?: string,
    /**
     * 昵称
     */
    NickName?: string
};

export default class AccountApi {
    /**
     * 创建账号
     */
    public CreateAccountAsync(input: InputCreateAccount) {
        return Tools.FetchAsync("Account/CreateAccount", input, "POST");
    }

    /**
     * 获取我的创建的子账号列表
     * @param page 
     * @param pageSize 
     */
    public GetMySubAccountListAsync(page: number, pageSize: number) {
        return Tools.FetchAsync<{
            allcount: number,
            pagecount: number,
            data: ad_account[]
        }>("Account/GetMySubAccountList", {
            page,
            pageSize
        }, "GET");
    }

    /**
     * 修改账号User数据
     * @param input 
     * @returns 
     */
    public UpdateAccountUserInfoAsync(input: InputUpdateAccountUserInfo) {
        return Tools.FetchAsync("Account/UpdateAccountUserInfo", input, "POST", "multipart/form-data");
    }


    /**
     * 设置账号状态
     * @param toUid 
     * @param status 
     * @returns 
     */
    public SetAccountStatusAsync(toUid: string, status: AccountStatusEnum) {
        return Tools.FetchAsync(`Account/SetAccountStatus?toUid=${toUid}&status=${status}`, {}, "PUT");
    }

    /**
     * 修改登录密码
     * @param password 
     */
    public UpdatePasswordAsync(password: string) {
        return Tools.FetchAsync(`Account/SetAccountStatus?password=${password}`, {
        }, "PATCH");
    }
    /**
     * 设置密码
     * @param toUid 
     * @param oldPassword 
     * @param newPassword 
     */
    public SetPasswordAsync(toUid: string, oldPassword: string, newPassword: string) {
        return Tools.FetchAsync(`Account/SetPassword?toUid=${toUid}&oldPassword=${oldPassword}&newPassword=${newPassword}`, {
        }, "PATCH");
    }

    /**
     * 获取登录账号信息数据
     */
    public GetUserInfoAsync() {
        return Tools.FetchAsync<AccountVO>(`Account/GetUserInfo`, {
        }, "GET");
    }

    /**
     * 账号充值
     */
    public RechargeAsync() {
        return Tools.FetchAsync(`Account/Recharge`, {
        }, "POST");
    }

    /**
     * 设置账号余额
     */
    public SetUserBalanceAsync(input: InputSetUserBalance) {
        return Tools.FetchAsync(`Account/SetUserBalance`, input, "POST");
    }
}